<template lang="pug">
SspLayout(area="core")
  template(slot="actions")
    .form-inline
      .form-group.m5
        label Show deleted: &nbsp;
        input.deleted-products-checkbox(type="checkbox" v-model="deleted" @change="$refs.grid.reload()")
      .form-group.m5
        input.form-control.product-filter(placeholder="Product filter" @input="onFilterInput($event.target.value)")
      .form-group.m5
        router-link.btn.btn-primary.add-new-product-button(:to="{name: 'productNew'}")
          i.fa.fa-plus
          span.ml5 New Product

  DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)" url-page-param="page")
    tr(slot="thead")
      th Name
      th Alias
      th GTIN
      th Product ID
      th Validation Response Group
      th
    tr(v-for="p in products")
      td {{p.name}}
      td {{p.alias}}
      td {{p.gtin}}
      td {{p.customerProductReference}}
      td {{p.atiGroupName}}
      td.actions
        router-link.btn-view(:to="{name: 'product', params: {id: p.productId}}") View
        router-link.btn-edit(:to="{name: 'productEdit', params: {id: p.productId}}" title="Edit")
        button.btn-restore(title="Undelete product" @click="undelete(p.productId)" v-if="p.deleted")
</template>
<script>
import debounce from 'debounce'
import miniToastr from 'mini-toastr'
import DataGrid from '@/components/ssp/DataGrid'
import Masterdata from '@/service/apis/Masterdata'

export default {
  data: () => ({
    deleted: false,
    products: [],
    filter: ''
  }),
  created() {
    this.onFilterInput = debounce(this.onFilterInput, 200);
  },
  methods: {
    onFilterInput(filter) {
      this.filter = filter
      this.$refs.grid.reload(true)
    },
    fetchData(page) {
      const req = page.pageRequest()
      if (this.deleted) {
        req.deleted = this.deleted
      }
      req.filter = this.filter
      return Masterdata.listProducts(req)
        .then((resp) => {
          this.products = resp.data.content
          return resp.data.totalElements
        })
    },
    undelete(id) {
      this.$confirm({ text: 'Are you sure you want to undelete this product?' })
        .then((conf) => {
          if (conf) {
            Masterdata.undeleteProduct(id)
              .then(() => {
                miniToastr.success('Product was undeleted')
                this.$refs.grid.reload()
              })
              .catch((e) => { this.$emit('error', e) })
          }
        })
    }
  },
  components: {
    DataGrid
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/configuration/product/Products.vue